import { AssertMetadataRequest } from '../../types/pwa/AssertMetadataRequest';
import { AssertMetadataResponse } from '../../types/pwa/AssertMetadataResponse';
import { FulfillOffIpRequestResource } from '../../types/pwa/FulfillOffIpRequestResource';
import { PwaInstance } from '../../types/pwa/PwaInstance';
import { RegisterPwaInstanceResponse } from '../../types/pwa/RegisterPwaInstanceResponse';
import { RegisterResource } from '../../types/pwa/RegisterResource';
import { UpdateMetadataRequest } from '../../types/pwa/UpdateMetadataRequest';
import {
  GetOneFromPath,
  Post,
  PostUsingQueryParameters,
  PostWithResponse,
  Put,
  PutWithResponse,
} from '../api/GenericClient';

const initialPath = '/pwa';

async function registerPwa(
  registerResource: RegisterResource,
): Promise<RegisterPwaInstanceResponse> {
  const path = `/register`;
  const apiPath = initialPath.concat(path);

  return await Post(apiPath, registerResource);
}

async function assertMetaData(
  request: AssertMetadataRequest,
  pwaInstanceId: string,
): Promise<AssertMetadataResponse> {
  const path = `/assertMetadata`;
  const apiPath = initialPath.concat(path);

  return await Post(apiPath, request);
}

async function updateMetaData(request: UpdateMetadataRequest, pwaInstanceId: string): Promise<any> {
  const path = `/updateMetadata`;
  const apiPath = initialPath.concat(path);

  return await Put(apiPath, request);
}

async function requestOffIpAccess(pwaInstanceId: string): Promise<any> {
  const path = `/requestOffIpAccess`;
  const apiPath = initialPath.concat(path);

  return await PostUsingQueryParameters(apiPath);
}

async function fulfillOffIpRequest(
  fulfillOffIpRequestResources: Array<FulfillOffIpRequestResource>,
): Promise<any> {
  const path = `/fulfillOffIpRequest`;
  const apiPath = initialPath.concat(path);

  return await PostWithResponse(apiPath, fulfillOffIpRequestResources);
}

async function revokeOffIpAccess(revokePwaInstanceIds: Array<string>): Promise<any> {
  const path = `/revokeOffIpAccess`;
  const apiPath = initialPath.concat(path);

  return await PutWithResponse(apiPath, revokePwaInstanceIds);
}

async function getCurrentInstance(): Promise<PwaInstance> {
  const path = `/currentInstance`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

async function checkAdminsAvailability(): Promise<any> {
  const path = `/mobileAdminsAvailability`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

async function getMobileOffIpAccessActiveService(): Promise<boolean> {
  const path = `/isMobileOffIpAccessEnabled`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

async function getMobileEnabledFeatureToggle(): Promise<boolean> {
  const path = '/pwa/isMobileEnabled';

  return await GetOneFromPath(path);
}

async function hasSingleDealerGroupAccess(): Promise<boolean> {
  const path = `/hasSingleDealerGroupAccess`;
  const apiPath = initialPath.concat(path);

  return await GetOneFromPath(apiPath);
}

export const PwaService = {
  registerPwa,
  assertMetaData,
  updateMetaData,
  requestOffIpAccess,
  fulfillOffIpRequest,
  revokeOffIpAccess,
  getCurrentInstance,
  checkAdminsAvailability,
  getMobileOffIpAccessActiveService,
  getMobileEnabledFeatureToggle,
  hasSingleDealerGroupAccess
};
